<ion-header>
  <ion-toolbar>
    <ion-title>Enter new text for model inferencing</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal('close')">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
  
    <ion-content class="no-hover-page" [fullscreen]="true" >
      
      <ng-container >
        <form [formGroup]="addTextForm" (ngSubmit)="onSubmit()" class="addtext-form" style="margin-top: 25px;">
          <ion-list>
            <div formArrayName="textArray">
              <div *ngFor="let formEntry of textArray.controls; let i = index" [formGroupName]="i">
                <ion-card>
                    <div class="remove-button-container" *ngIf="textArray.length > 1">
                      <ion-button
                        fill="clear"
                        color="danger"
                        (click)="removeFormEntry(i)"
                        class="remove-button"
                      >
                        <ion-icon name="close-outline"></ion-icon>
                      </ion-button>
                    </div>
    
                  <ion-card-content>
                    <ion-item class="form-item">
                      <ion-input 
                        formControlName="message"
                        type="text"
                        required
                        placeholder="Enter your text here ..."
                      ></ion-input>
                    </ion-item>
      
                  </ion-card-content>
                </ion-card>
              </div>
            </div>
            <ion-row>

              
            </ion-row>
            
            <ion-row>  
              <ion-col size="10"></ion-col>
              <ion-col size="2">  
                <ion-item lines="none" style="cursor: pointer;">  
                    <ion-icon slot="end" name="add-outline" (click)="addFormEntry()"></ion-icon>
                </ion-item>
              </ion-col>
            </ion-row>

            

          
            <ion-button type="submit" expand="block" class="submit-button" [disabled]="addTextForm.invalid">Save</ion-button>
          </ion-list>
        </form>
      </ng-container>
    </ion-content>
    

  
